import $ from 'jquery'

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight

  const logoContainer = document.querySelector('.site-branding')
  const logoContainerWidth = logoContainer.clientWidth

  const footerLogoContainer = document.querySelector('.footer__logo')
  const footerLogoContainerWidth = footerLogoContainer.clientHeight

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
  body.style.setProperty('--site-branding', `${logoContainerWidth}px`)
  body.style.setProperty('--footer-logo', `${footerLogoContainerWidth}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  window.location.href = $(this).attr('data-url')
})
